import React, { useState } from "react";
import { usePagination } from "../../../hooks/usePagination";
import ResultHandler from "../../../components/ResultHandler";
import PaginationHandler from "../../../components/PaginationHandler";
import TableHeaderHandler from "../../../components/TableHeaderHandler";
import { useTranslation } from "react-i18next";
import TableAction from "../../../components/TableAction";
import EmptyData from "../../../components/EmptyData";
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../api/permissions";
import moment from "moment";
import { useParams } from "react-router-dom";
import { useResponse } from "../../../hooks/useResponse";
import DeleteModal from "../../../components/Common/DeleteModal";
import { deleteLeave, getLeaves } from "../../../api/leaves";
import { Badge, Button } from "reactstrap";
import EditStatusModal from "./EditStatusModal";

const STATUSE = {
  Pending: { color: "warning", text: "Pending" },
  Approved: { color: "success", text: "Approved" },
  Rejected: { color: "danger", text: "Rejected" },
};

export default function LeavesTable() {
  const { t } = useTranslation();
  const { id: employeeId } = useParams();

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
    setMeta,
  } = usePagination(getLeaves, employeeId ? { employeeId: employeeId } : null);

  // delete
  const [show, setShow] = useState(false);
  const [deletingLeave, setDeletingLeave] = useState(null);

  const { setData } = useResponse(deleteLeave, () => {
    setShow(false);
    setDeletingLeave(null);
    setPayload({ employeeId: employeeId, ref: true });
  });

  function onDeleteClick() {
    setData({ type: "delete", data: deletingLeave });
  }

  function onCloseClick() {
    setShow(false);
  }

  // Edit Status
  const [editedEntity, setEditedEntity] = useState(null);
  const [editStatusModalOpen, setEditStatusModalOpen] = useState(false);

  return (
    <>
      <TableHeaderHandler
        permission={PERMISSIONS.LEAVES_CREATE}
        addUrl={employeeId ? "/add-leave/" + employeeId : "/add-leave/noId"}
        setPage={setPage}
        setPerPage={setPerPage}
      ></TableHeaderHandler>

      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                {!employeeId && <Th>Employee</Th>}
                <Th>Type</Th>
                <Th>From</Th>
                <Th>To</Th>
                <Th>Status</Th>
                <Th style={{ width: "20%" }}>{t("tables.Action")}</Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.holidays.map((row) => {
                  return (
                    <Tr key={row.id}>
                      {!employeeId && <Td>{row.employee.name}</Td>}
                      <Td>{row.type}</Td>
                      <Td>
                        {row.from
                          ? moment(row.from).format("DD MMM YYYY")
                          : "-"}
                      </Td>
                      <Td>
                        {row.to ? moment(row.to).format("DD MMM YYYY") : "-"}
                      </Td>
                      <Td className="d-flex gap-2 align-items-center">
                        <Badge
                          style={{ fontSize: "12px", padding: "4px 6px" }}
                          color={STATUSE[row.status]?.color}
                        >
                          {STATUSE[row.status]?.text}
                        </Badge>
                        <Button
                          size="sm"
                          style={{ padding: "2px 4px" }}
                          color="primary"
                          onClick={() => {
                            setEditedEntity(row);
                            setEditStatusModalOpen(true);
                          }}
                        >
                          <i className="bx bx-edit font-size-14 align-middle" />
                        </Button>
                      </Td>
                      <Td>
                        <TableAction
                          hasEdit={true}
                          editPermission={PERMISSIONS.LEAVES_EDIT}
                          hasDelete={true}
                          deletePermission={PERMISSIONS.LEAVES_DELETE}
                          type="leave"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingLeave}
                        />
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            )}
          </Table>

          {!loading && (
            <EmptyData
              empty={response.data && response.data.holidays.length === 0}
              msg="No Data Found."
            />
          )}

          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}

          <ResultHandler error={error} loading={loading} />

          <EditStatusModal
            isOpen={editStatusModalOpen}
            handleClose={() => setEditStatusModalOpen(false)}
            holiday={editedEntity}
            hnadleRefresh={() =>
              setPayload({ employeeId: employeeId, ref: true })
            }
          />
        </div>
      </div>
    </>
  );
}
